<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem>参展商胸卡信息登记表</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">参展商胸卡信息登记表</div>
            </div>
            <div class="header-tool-box">
                <!-- <div class="htb-item" @click="addClick">
                    <span>+ 添加</span>
                </div> -->
                <div class="htb-item" @click="goOne">
                    <span>返回首页</span>
                </div>
            </div>
        </div>
        <div class="marginCss20">
            <p class="fontWig">截止日期：{{ endDate }}</p>
            <!-- <p class="fontWig marginTop20">《广州国际分析测试及实验室设备展览会暨技术研讨会会刊》是大会组委会唯一指定的参展商、参观商会刊资料。</p> -->
            <div class="paddingCss20 backBlue marginTop20">
                <p v-html="instructions"></p>
            </div>
        </div>
           <div class="header-tool" >
                      <div  class="header-tool-box">
                <div class="htb-item" style='width: 80px;
    height: 40px;' @click="addClick">
                    <span>+ 添加</span>
                </div>
                </div>
            </div>
        <div style="padding: 20px">
            <el-table :data="list" style="width: 100%" row-key="id" :stripe="true"
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
      
                <el-table-column  type="index" label="序号"  align="center" />
                <el-table-column prop="name" label="姓名"  align="center" />
                <el-table-column prop="idCardNo" label="身份证" align="center" />
                <el-table-column prop="gender" label="性别" align="center" />
                <el-table-column prop="phoneNumber" label="手机号" align="center" />
                <el-table-column prop="department" label="部门" align="center" />
                <el-table-column prop="jobTitle" label="职务" align="center" />
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="small" @click="editHandle(scope.row)">编辑</el-button>
                            <span class="u-split">|</span>
                            <el-popover :ref="`popover-${scope.$index}`" trigger="click" visible-arrow="false"
                                placement="top">
                                <p style="text-align: right; margin-bottom: 15px">您确定要删除吗？</p>
                                <div style="margin:0 auto;text-align: center;">
                                    <el-button size="mini" type="text"
                                        @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">取消</el-button>
                                    <el-button type="primary" size="mini" @click="delItem(scope.row);scope._self.$refs[`popover-${scope.$index}`].doClose()">确定</el-button>
                                </div>
                                <span slot="reference" style="color: #d9001b;cursor: pointer;;font-size: 12px;">删除
                                </span>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="my-page">
            <el-pagination hide-on-single-page background :current-page="page" :page-sizes="[10, 20, 30, 40]"
                :page-size="size" layout="total,  prev, pager, next, sizes, jumper" :total="totalCount"
                @size-change="changePageSize" @current-change="changePage" />
        </div> -->



        <div class="marginCss20">
            <div class="paddingCss20 backBlue marginTop20">
                <span v-html="contactIllustrate"></span>
            </div>
        </div>

        <el-dialog :title="title" :visible.sync="showModal" width="600px" :close-on-click-modal="false"
            @close="cancel('addForm')">
            <div style="width: 90%">
                <el-form ref="addForm" :model="form" :rules="rules" label-width="100px" size="small">
                    <el-form-item label="姓名:" prop="name">
                        <el-input v-model="form.name" placeholder="请输入姓名" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证:" prop="idCardNo">
                        <el-input v-model="form.idCardNo" placeholder="请输入身份证" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="性别:" prop="gender">
                        <el-radio-group v-model="form.gender">
                            <el-radio label="男"></el-radio>
                            <el-radio label="女"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机号:" prop="phoneNumber">
                        <el-input v-model="form.phoneNumber" placeholder="请输入手机号" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="部门:" prop="department">
                        <el-input v-model="form.department" placeholder="请输入部门" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="职务:" prop="jobTitle">
                        <el-input v-model="form.jobTitle" placeholder="请输入职务" maxlength="50"></el-input>
                    </el-form-item>

                </el-form>
            </div>
            <span slot="footer">
                <el-button @click="cancel('addForm')" size="small">取消</el-button>
                <el-button type="primary" @click="submitHandle('addForm')" :loading="btnloading" size="small">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
    name: "exhibition-info-catalogue",
    data () {

        return {
            catalogueInfoIsHave: false, // 会刊信息是否存在
            page: 1,
            size: 100,
            totalCount: 0,
            list: [
                {
                    value: "10人以下",
                    label: "10人以下"
                },
                {
                    value: "10~50人",
                    label: "10~50人"
                }
            ],
            btnloading: false,
            showModal: false,
            form: {
                name: "",
                idCardNo: "",
                gender: "",
                phoneNumber: "",
                department: "",
                jobTitle: ""
            },
            rules: {
                name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                idCardNo: [{ required: true, message: "请输入身份证", trigger: "blur" },
                { pattern: /^(^\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/, message: "身份证格式不正确", trigger: "blur" },
            ],
                gender: [{ required: true, message: "请输入性别", trigger: "blur" }],
                phoneNumber: [{ required: true, message: "请输入手机号", trigger: "blur" },
                { pattern: /^[1][0-9]{10}$/, message: "手机号格式不正确", trigger: "blur" },
            ],
                department: [{ required: true, message: "请输入部门", trigger: "blur" }],
                jobTitle: [{ required: true, message: "请输入职务", trigger: "blur" }],

            },
            countryList: [],
            provinceArr: [],
            citiesArr: [],
            // exTypeList: [],
            uploadList: [],
            defaultList: [],
            loading: false,
            endDate: null,
            instructions: null,
            contactIllustrate: null,
         
            title: '',
            editInfo:null,
            IsSubmitDeadlineToo:false
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
        }),
        exhibitionId () {
            return this.exhibition.id;
        },
    },
    created () {
        this.init();
    },

    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            getcardrecordList: 'exhibitionModule/getcardrecordList', //获取列表
            creatCardrecord: 'exhibitionModule/creatCardrecord', //新增
            updateCardrecord: 'exhibitionModule/updateCardrecord', //编辑
            deleteCardrecord: 'exhibitionModule/deleteCardrecord', //删除

        }),
        goOne () {
            this.$router.push(`/exhibition/index/home`);

        },
        async init () {
            let opt = {
                providerName: "Global",
                names: ['Card.SubmitDeadline', 'Card.FormDescription', 'Card.ContractDescription','Card.IsSubmitDeadlineToo']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                console.log(res, 'res');
                if (res[0].value) {

                    console.log(this.endDate, 'res');
                    let dateStr = res[0].value;
                    let date = new Date(dateStr);
                    let year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    let day = date.getDate();
                    let formattedDate = year + "年" + (month < 10 ? "0" + month : month) + "月" + (day < 10 ? "0" + day : day) + "日";
                    console.log(formattedDate); // "2023年05月19日"
                    // this.endDate = formattedDate
                    this.endDate = res[0].value

                }
                if (res[1].value) {
                    this.instructions = res[1].value
                }
                if (res[2].value) {
                    this.contactIllustrate = res[2].value
                }
                this.IsSubmitDeadlineToo = res[3].value
            }
            await this.getList()

        },
        async getList () {
            console.log(this.exhibitor,'this.exhibitor.id');
            let opt = {
                id: this.exhibitor.id,
                ExhibitionId: this.exhibitor.exhibitionId,
                Page: this.page,
                Size: this.size,
            }
            let res = await this.getcardrecordList(opt)
            if (res) {
                console.log(res);
                this.list = res.items
            }
        },
        addClick () {
            // console.log(this.list.length);
            // if(this.list.length>20){
            //     this.$message.warning("每家展商限制添加二十个");
            //     return
            // }
            this.title = '添加'
            this.showModal = true
            this.editInfo=null
            this.form.name=''
            this.form.idCardNo=''
            this.form.gender=''
            this.form.phoneNumber=''
            this.form.department=''
            this.form.jobTitle=''

        },
        editHandle (e) {
            this.title = '编辑'
            this.showModal = true
            this.form.name=e.name
            this.form.idCardNo=e.idCardNo
            this.form.gender=e.gender
            this.form.phoneNumber=e.phoneNumber
            this.form.department=e.department
            this.form.jobTitle=e.jobTitle
            this.editInfo=e

        },
        async submitHandle (name) {

            let bool = this.regular.contrastDate(this.regular.compareDate(), this.endDate)
            // 为true 截止日期到了 不能提交
            if (bool) {
                console.log(bool);
                console.log(this.IsSubmitDeadlineToo,typeof(this.IsSubmitDeadlineToo));
                if (this.IsSubmitDeadlineToo=='false') {
                    this.$message.warning("超过截止日期不能提交");
                    return
                }
            }

            let valid = await this.validForm(name);
            if (!valid) return;
            this.btnloading = true;
            setTimeout(() => {
                this.btnloading = false;
            }, 5000);
            let res = null;
            if (this.editInfo) {
                res = await this.editForm();
            } else {
                res = await this.addForm();
            }
            if (res) {
                this.$emit("finish");
                this.$notify({
                    title: '成功',
                    message: '操作成功！',
                    type: 'success'
                });
                this.getList();
                this.cancel()
                // this.showModal=false
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试'
                });
                this.btnloading = false;
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        cancel () {
            this.$refs["addForm"].resetFields();
            this.$emit("close");
            this.btnloading = false;
            this.showModal = false;
        },
        validField (name) {
            // 验证单个控件
            setTimeout((c) => {
                this.$refs.form.validateField(name);
            }, 400);
        },
        async addForm () {
            let opt = {
                id: this.exhibitor.id,
                body: {
                    name: this.form.name,
                    idCardNo: this.form.idCardNo,
                    gender: this.form.gender,
                    phoneNumber: this.form.phoneNumber,
                    department: this.form.department,
                    jobTitle: this.form.jobTitle,
                }
            };
            let res = await this.creatCardrecord(opt);
            return Promise.resolve(res);
        },
        async editForm () {
            let opt = {
                id: this.editInfo.id,
                body: {
                    name: this.form.name,
                    idCardNo: this.form.idCardNo,
                    gender: this.form.gender,
                    phoneNumber: this.form.phoneNumber,
                    department: this.form.department,
                    jobTitle: this.form.jobTitle,
                },
            };
            let res = await this.updateCardrecord(opt);
            //   let list = await this.CategoryMutation({groupId: this.group.id});
            //   console.log(list);
            return Promise.resolve(res);
        },

        //删除
        async delItem(e){
            let res = await this.deleteCardrecord(e.id);
            if(res){
                this.$notify({
                    title: '成功',
                    message: '操作成功！',
                    type: 'success'
                });
                this.getList()
            }else{
                this.$notify.error({
                    title: '错误',
                    message: '操作失败，请重新尝试'
                }); 
            }
        }
    },
};
</script>

<style lang="scss">
.intTextarea {
    .ivu-form-item-error-tip {
        top: 75%;
    }
}

.no-label {
    .ivu-form-item-label:before {
        opacity: 0 !important;
    }
}
</style>
<style scoped lang="scss"></style>
